import React from "react";
import { PRIVATE_PARTY_FEES } from "../data/packages";
import "../css/PrivateParty.css";

export default function PrivatePackageFacts({ pkg }) {
  return (
    <div className="private-package-facts">
      <dl className="private-package-capacity">
        <div>
          <dt>Duration</dt>
          <dd>{pkg.durationHours} hours</dd>
        </div>
        <div>
          <dt>Included kids</dt>
          <dd>{pkg.includedKids}</dd>
        </div>
        <div>
          <dt>Included adults</dt>
          <dd>{pkg.includedAdults}</dd>
        </div>
      </dl>
      <div className="private-package-extras">
        <p>Additional kids: ${PRIVATE_PARTY_FEES.additionalKid} each</p>
        <p>Additional adults: ${PRIVATE_PARTY_FEES.additionalAdult} each</p>
      </div>
    </div>
  );
}
